import "./ResetPassword.scss";
import Logo from "../../../assets/images/logo-color.png";
import { RPassword, RButton } from "../../../components/Controls";
import { NavLink } from "react-router-dom";
import LoginParticles from "../Login/LoginParticles";

export default function ResetPassword() {
  const { t } = this.props;
  var { curItem } = this.state;

  return (
    <div className="reset-password">
      <div className="main-login">
        <div className="content">
          <div className="main-form">
            <div className="logo">
              <NavLink to="/">
                <img src={Logo} alt="Phần mềm quản lý bán hàng" />
              </NavLink>
            </div>
            <h1>{t("reset_password.title")}</h1>
            <div className="form">
              <div className="row">
                <div className="col-xl-12 col-lg-12 col-md-4 col-12">
                  <div className="mb-3">
                    <RPassword
                      label={t("reset_password.password")}
                      inputClass="form-control"
                      inputId="password"
                      inputName="password"
                      value={curItem.password}
                      onChange={(e) => {
                        this.handleInputChange(e);
                        this.validateOne(e);
                      }}
                      maxLength={100}
                    />
                  </div>
                </div>

                <div className="col-xl-12 col-lg-12 col-md-4 col-12">
                  <div className="mb-3">
                    <RPassword
                      label={t("reset_password.password_confirm")}
                      inputClass="form-control"
                      inputId={"password_confirm"}
                      inputName={"password_confirm"}
                      value={curItem.password_confirm}
                      onChange={(e) => {
                        this.handleInputChange(e);
                        this.validateOne(e);
                      }}
                      maxLength={30}
                    />
                  </div>
                </div>

                <div className="col-xl-12 col-lg-12 col-md-4 col-12">
                  <RButton
                    onClick={this.onSaveAction.bind(this)}
                    className="btn btn-save"
                    text={t("reset_password.save")}
                    title={t("reset_password.save")}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <LoginParticles />
    </div>
  );
}
